export enum SmartOMeterTiers {
  TIER_1 = 'Tier 1',
  TIER_2 = 'Tier 2',
  TIER_3 = 'Tier 3',
  TIER_4 = 'Tier 4',
  TIER_5 = 'Tier 5',
  TIER_6 = 'Tier 6',
  TIER_7 = 'Tier 7',
  TIER_8 = 'Tier 8',
  TIER_9 = 'Tier 9',
  TIER_10 = 'Tier 10',
  TIER_11 = 'Tier 11',
  TIER_12 = 'Tier 12',
  TIER_13 = 'Tier 13',
  TIER_14 = 'Tier 14',
  TIER_15 = 'Tier 15',
  TIER_16 = 'Tier 16'
}

export type SmartOMeterTier = SmartOMeterTiers.TIER_1 | SmartOMeterTiers.TIER_2 | SmartOMeterTiers.TIER_3 | SmartOMeterTiers.TIER_4 | SmartOMeterTiers.TIER_5 | SmartOMeterTiers.TIER_6 | SmartOMeterTiers.TIER_7 | SmartOMeterTiers.TIER_8 | SmartOMeterTiers.TIER_9 | SmartOMeterTiers.TIER_10 | SmartOMeterTiers.TIER_11 | SmartOMeterTiers.TIER_12 | SmartOMeterTiers.TIER_13 | SmartOMeterTiers.TIER_14 | SmartOMeterTiers.TIER_15 | SmartOMeterTiers.TIER_16;
